export default __webpack_public_path__ + "static/Declaration_SMFS-e3a4aa673e1b31b88e39b3f378e47389.pdf";